module.exports = __webpack_public_path__ + "img/Dantam Fashion 08.5312cf9a.jpg";